import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonial() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--cream)] py-24 md:py-32" data-id="element-276">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto px-6" data-id="element-277">
        <div className="relative bg-white p-12 md:p-16 rounded-2xl shadow-xl border-2 border-[var(--warm-gold)]/20" data-id="element-278">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-[var(--warm-gold)]/20" data-id="element-279" />

          <div className="space-y-8 text-center relative z-10" data-id="element-280">
            <div className="flex justify-center gap-1" data-id="element-281">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[var(--warm-gold)] text-[var(--warm-gold)]" data-id="element-282" />)}
            </div>

            <blockquote className="font-display text-2xl md:text-3xl italic text-[var(--dusk-purple)] leading-relaxed" data-id="element-283">
              "Un viaje de descubrimientos que cambia vidas."
            </blockquote>

            <div className="pt-4" data-id="element-284">
              <p className="font-semibold text-lg text-[var(--charcoal)]" data-id="element-285">
                Samantha Castro
              </p>
            </div>
          </div>

          <Quote className="absolute bottom-8 right-8 w-12 h-12 text-[var(--warm-gold)]/20 rotate-180" data-id="element-286" />
        </div>

        <div className="relative bg-white p-12 md:p-16 rounded-2xl shadow-xl border-2 border-[var(--warm-gold)]/20 mt-8" data-id="element-287">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-[var(--warm-gold)]/20" data-id="element-288" />

          <div className="space-y-8 text-center relative z-10" data-id="element-289">
            <div className="flex justify-center gap-1" data-id="element-290">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[var(--warm-gold)] text-[var(--warm-gold)]" data-id="element-291" />)}
            </div>

            <blockquote className="font-display text-2xl md:text-3xl italic text-[var(--dusk-purple)] leading-relaxed" data-id="element-292">
              "Llevaba años sintiéndome rota por dentro y fingiendo que estaba
              bien. Este libro fue lo primero que no me pidió sonreír — me pidió
              mirar. Y por primera vez en mucho tiempo, volví a respirar."
            </blockquote>

            <div className="pt-4" data-id="element-293">
              <p className="font-semibold text-lg text-[var(--charcoal)]" data-id="element-294">
                Carolina Méndez
              </p>
            </div>
          </div>

          <Quote className="absolute bottom-8 right-8 w-12 h-12 text-[var(--warm-gold)]/20 rotate-180" data-id="element-295" />
        </div>
      </motion.div>
    </section>;
}